import React, { useEffect, useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { KycStep } from "../components/KycStep";

export function SuccessStep({ returnUrl }) {
  const { t } = useTranslation();
  const [secondsRemaining, setSecondsRemaining] = useState(3);

  useEffect(() => {
    if (!returnUrl) return undefined;

    // 所有成功入口统一停留 3 秒展示结果，然后返回 A 站；按钮允许用户立即返回。
    setSecondsRemaining(3);
    const countdownTimer = window.setInterval(() => {
      setSecondsRemaining((current) => Math.max(0, current - 1));
    }, 1000);
    const redirectTimer = window.setTimeout(() => {
      window.location.replace(returnUrl);
    }, 3000);

    return () => {
      window.clearInterval(countdownTimer);
      window.clearTimeout(redirectTimer);
    };
  }, [returnUrl]);

  return (
    <KycStep labelledBy="kyc-success-title" className="kyc-status-step">
      <div className="flex min-h-[42dvh] flex-col items-center justify-center py-4 text-center">
        <span className="flex size-16 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100">
          <Check className="size-7" strokeWidth={2.4} aria-hidden="true" />
        </span>
        <h1
          id="kyc-success-title"
          className="mt-7 text-[1.75rem] font-semibold leading-tight tracking-[-0.035em] text-slate-950"
        >
          {t("kyc.success.title")}
        </h1>
        <p className="mt-3 max-w-md text-sm leading-6 text-slate-600">
          {t("kyc.success.description")}
        </p>
        {returnUrl ? (
          <>
            <p className="mt-5 text-sm font-medium text-slate-500">
              {t("kyc.success.redirecting", { count: secondsRemaining })}
            </p>
            <a
              href={returnUrl}
              className="mt-4 inline-flex min-h-12 w-full max-w-sm items-center justify-center gap-2 rounded-lg bg-teal-700 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-800 active:scale-[0.99]"
            >
              {t("kyc.success.return")}
              <ArrowUpRight className="size-4" aria-hidden="true" />
            </a>
          </>
        ) : (
          <p className="mt-7 rounded-lg bg-slate-100 px-4 py-3 text-xs text-slate-600">
            {t("kyc.success.close")}
          </p>
        )}
      </div>
    </KycStep>
  );
}
